/**
 * Page size for report exports (ARCH / AFE Excel + PDF).
 *
 * Resolution order: the user's explicit choice → the company (tenant) default →
 * A4. `null` on the user preference means "Auto — follow the company default".
 * The resolved value is sent to the backend as `?paper=…`; the backend treats
 * A4 as a no-op (preserving the verified byte output) and re-serializes other
 * sizes. Ecuador commonly mixes A4 / Letter / Oficio, so this is never hardcoded.
 */
import type { Tenant } from "@oxbo/tokens";

export const PAPER_SIZES = ["A4", "Letter", "Legal", "Oficio"] as const;
export type PaperSize = (typeof PAPER_SIZES)[number];

export function isPaperSize(v: unknown): v is PaperSize {
  return typeof v === "string" && (PAPER_SIZES as readonly string[]).includes(v);
}

/** Per-company default. Orion (Ecuador) files are A4; default everyone to A4. */
const COMPANY_DEFAULT: Partial<Record<Tenant, PaperSize>> = {
  // add overrides here if a tenant standardizes on Letter/Oficio
};

/** Resolve the effective page size: user choice → company default → A4. */
export function resolvePaperSize(userChoice: PaperSize | null, tenant: Tenant): PaperSize {
  return userChoice ?? COMPANY_DEFAULT[tenant] ?? "A4";
}
